/**************************************************
 * Nombre:       TituloTexto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const TituloTexto = ({titulo, texto, dir = 'flex-start', textoS = 24, mt = 0, colorT='#ffffff90'}) => {

    return (
        <Grid
            container
            justifyContent={dir}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: dir}}>
                <Typography sx={{lineHeight: 1.1, fontWeight: 300, fontSize: 14, color: colorT}}>{titulo}</Typography>
            </Grid>
            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: dir, marginTop: mt}}>
                <Typography sx={{lineHeight: 1.1, fontWeight: 700, fontSize: textoS, }}>{texto}</Typography>
            </Grid>

        </Grid>
    )

}
export default TituloTexto